import { render, staticRenderFns } from "./campaignPosts.vue?vue&type=template&id=65aefe13&scoped=true&"
import script from "./campaignPosts.vue?vue&type=script&lang=js&"
export * from "./campaignPosts.vue?vue&type=script&lang=js&"
import style0 from "./campaignPosts.vue?vue&type=style&index=0&id=65aefe13&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65aefe13",
  null
  
)

export default component.exports